/**
 * FXC-8601 — internal "60-day delivery record" page.
 *
 * A self-contained static artifact (vanilla HTML/CSS/JS, no build step) that lives
 * under `public/internal/60-day-record/`. It is shown full-screen in an iframe and
 * gated to @flexcompute.com staff via <FlexcomputeOnlyGuard> at the route (see App.tsx).
 *
 * Note: the guard is client-side defence-in-depth. The raw static path
 * (`/internal/60-day-record/index.html`) is served by the CDN and is not itself
 * auth-gated — true server-side/edge gating is a follow-up if the content ever needs
 * to be secret. Today it is internal-only and unlinked from the app chrome.
 */
export default function SixtyDayRecordPage() {
  const src = `${import.meta.env.BASE_URL}internal/60-day-record/index.html`;
  return (
    <iframe
      src={src}
      title="Thread — 60-Day Delivery Record"
      style={{
        position: "fixed",
        inset: 0,
        width: "100%",
        height: "100%",
        border: 0,
        display: "block",
      }}
    />
  );
}
